import { createApp } from 'vue';
import AWS from 'aws-sdk';
import Maska from 'maska';
import velocity from 'velocity-animate';
import Notifications from '@kyvg/vue3-notification';
import VueLogger from 'vuejs3-logger';
import VueUniversalModal from 'vue-universal-modal';
import environments from './globals/environments';
import utils from './mixins/Utils.vue';
import students from './mixins/Students.vue';
import store from './store';
import router from './routes';
import App from './App.vue';

import 'vue-universal-modal/dist/index.css';
import 'cropperjs/dist/cropper.css';
import './styles/main.scss';

const app = createApp(App);

app.config.globalProperties.$env = environments;
app.config.globalProperties.$aws = AWS;
app.config.globalProperties.$window = window;
app.mixin(utils);
app.mixin(students);
app.use(store);
app.use(router);
app.use(Maska);
app.use(Notifications, { velocity });
app.use(VueUniversalModal, {
  teleportTarget: '#modals',
});
app.use(VueLogger, {
  isEnabled: !environments.prod,
  logLevels: ['debug', 'info', 'warn', 'error', 'fatal'],
  stringifyArguments: false,
  showLogLevel: false,
  showMethodName: false,
  showConsoleColors: true,
});
app.mount('#lcu-ui');
